import { useState } from "react";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Breadcrumb from "@/components/base/Breadcrumb";
import SectionTitle from "@/components/base/SectionTitle";
import { readerComments } from "@/mocks/mangaData";

const sortTags = ["最热", "最新", "最有共鸣"];

export default function Community() {
  const [active, setActive] = useState("最热");

  return (
    <>
      <Navbar />
      <main className="mx-auto w-full max-w-7xl px-4 py-8 md:px-6 md:py-12">
        <Breadcrumb items={[{ label: "首页", to: "/" }, { label: "读者吐槽" }]} />
        <div className="mt-6">
          <SectionTitle
            eyebrow="读者吐槽"
            title="评论区里的真实声音"
            desc="这里不讲场面话，只讲大实话。被刀到、被爽到、被雷到，都可以来吐槽两句，同好之间最懂彼此。"
          />
        </div>

        <div className="mt-7 flex items-center justify-between gap-3">
          <div className="flex flex-wrap gap-2">
            {sortTags.map((s) => (
              <button
                key={s}
                type="button"
                onClick={() => setActive(s)}
                className={`whitespace-nowrap rounded-full px-4 py-2 text-sm transition-colors ${
                  active === s
                    ? "bg-primary-500 font-medium text-background-50"
                    : "bg-background-100 text-foreground-700 hover:bg-background-200"
                }`}
              >
                {s}
              </button>
            ))}
          </div>
          <button
            type="button"
            className="hidden whitespace-nowrap rounded-full border border-background-200 px-4 py-2 text-sm text-foreground-600 transition-colors hover:border-primary-300 hover:text-primary-700 sm:block"
          >
            我也要吐槽
          </button>
        </div>

        <div className="mt-8 space-y-4">
          {readerComments.map((c) => (
            <article
              key={c.id}
              className="rounded-2xl border border-background-200 bg-background-50 p-5"
            >
              <div className="flex flex-wrap items-center gap-3">
                <img src={c.avatar} alt={`${c.user}的头像`} className="h-12 w-12 rounded-full object-cover" />
                <div className="min-w-0">
                  <p className="text-sm font-semibold text-foreground-950">{c.user}</p>
                  <p className="mt-0.5 text-xs text-foreground-500">
                    {c.level} · {c.time}
                  </p>
                </div>
                <span className="ml-auto rounded-full bg-secondary-100 px-3 py-1 text-xs text-secondary-800">
                  关于：{c.topic}
                </span>
              </div>
              <p className="mt-4 text-sm leading-7 text-foreground-700 md:text-[15px]">“{c.text}”</p>
              <div className="mt-4 flex items-center gap-5 border-t border-background-200 pt-3 text-xs text-foreground-500">
                <button type="button" className="flex items-center gap-1 transition-colors hover:text-primary-700">
                  <i className="ri-thumb-up-line"></i>
                  {c.likes.toLocaleString()} 赞同
                </button>
                <button type="button" className="flex items-center gap-1 transition-colors hover:text-primary-700">
                  <i className="ri-chat-3-line"></i>
                  回复
                </button>
                <button type="button" className="flex items-center gap-1 transition-colors hover:text-primary-700">
                  <i className="ri-share-line"></i>
                  分享
                </button>
              </div>
            </article>
          ))}
        </div>
      </main>
      <Footer />
    </>
  );
}